import React from 'react';
import { motion } from 'framer-motion';
import { WalletIcon, FileTextIcon, UsersIcon } from 'lucide-react';
const reasons = [{
  title: 'Flexible Pricing',
  description: 'We adapt to your needs. Choose between Hourly Wage for smaller tasks or Fixed Contracts for large-scale projects.',
  icon: WalletIcon
}, {
  title: 'Free Estimates',
  description: 'No hidden costs. We provide transparent, no-obligation quotes before any work begins.',
  icon: FileTextIcon
}, {
  title: 'Local Expertise',
  description: 'A family-owned approach with big-company results. We know Washington landscapes intimately.',
  icon: UsersIcon
}];
export function WhyUs() {
  return <section className="relative py-32 overflow-hidden" data-id="element-257">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-258">
        <img src="https://cdn.magicpatterns.com/uploads/ngBkr9wbTzH6wtXkfUvPJx/heylloyd-image-1775569938042.png" alt="Landscaping background" className="w-full h-full object-cover" data-id="element-259" />
        <div className="absolute inset-0 bg-forest-dark/90 mix-blend-multiply" data-id="element-260" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-261">
        <div className="text-center mb-20" data-id="element-262">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-263">
            <span className="text-gold font-bold tracking-widest uppercase text-sm mb-3 block" data-id="element-264">
              The M&J Difference
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif" data-id="element-265">
              Why Choose Us?
            </h2>
            <div className="w-24 h-1.5 bg-gold mx-auto rounded-full" data-id="element-266"></div>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-267">
          {reasons.map((reason, index) => <motion.div key={reason.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="relative group" data-id="element-268">
              {/* Glassmorphism Card */}
              <div className="h-full bg-white/10 backdrop-blur-lg border border-white/20 rounded-3xl p-10 text-center hover:bg-white/15 transition-all duration-300 hover:-translate-y-2 shadow-2xl" data-id="element-269">
                <div className="w-24 h-24 mx-auto bg-forest/80 rounded-2xl flex items-center justify-center mb-8 border border-gold/30 group-hover:scale-110 transition-transform duration-500 shadow-inner" data-id="element-270">
                  <reason.icon className="w-12 h-12 text-gold" data-id="element-271" />
                </div>
                <h3 className="text-2xl font-bold mb-4 text-white font-serif" data-id="element-272">
                  {reason.title}
                </h3>
                <p className="text-gray-300 leading-relaxed font-light text-lg" data-id="element-273">
                  {reason.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}